export default __webpack_public_path__ + "static/media/icon03.5de30b63.svg";